module.exports = {
    title1:'Yeahgrowth is ',
    title2:'a one-stop refined ',
    title3:'advertising management platform',
    discribe1:'which has intelligent data monitoring,',
    discribe2:'visual advertising management,',
    discribe3:'transparent media placement,',
    discribe4:'customized market insights and independent authority management.',
    help1:'How can we ',
    help2:'help ',
    help3:'your business',
    helpdis:"Based on Yeahmobi's powerful AI data analysis capabilities and rich experience in advertising management, we are able to improve advertising delivery effectively and maximize advertising effect by building a full-chain refined management system, providing a variety of media traffic such as programmatic traffic etc.",
    introduce:'Yeahgrowth will present you the most professional media source introduction . ',
    introduce2:'Everything will start from here.',
    goal:'Reach Your Goal and Get Started Today！',
    views:'View Now',
    source:'Media Source',
    by:'by',
    lookmore:'Look More',
    forward:'Please look forward to',
    updated:'The content is continuously updated.'
}


// WEBPACK FOOTER //
// ./src/i18n/modules/channelPage/en.js